var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadCloud02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload-cloud-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M12.5 24L18.5 18M18.5 18L24.5 24M18.5 18V31.5M30.5 25.1143C32.3323 23.6011 33.5 21.3119 33.5 18.75C33.5 14.1937 29.8063 10.5 25.25 10.5C24.9222 10.5 24.6156 10.329 24.4492 10.0466C22.4931 6.72725 18.8816 4.5 14.75 4.5C8.5368 4.5 3.5 9.5368 3.5 15.75C3.5 18.8492 4.75317 21.6556 6.78042 23.6903",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloud02);
export default __webpack_public_path__ + "static/media/upload-cloud-02.fc6335c00cde4508bc87209068b5fd27.svg";
export { ForwardRef as ReactComponent };